import { createFileRoute } from "@tanstack/react-router";
import { ArticlesHub } from "@/components/marketing/ArticlesHub";
import { HUB_DICT_EN } from "@/lib/articles.dict";
import { getArticlesTree } from "@/lib/articles.functions";

const SITE_URL = "https://banana.cards";

export const Route = createFileRoute("/articles/")({
  loader: () => getArticlesTree({ data: { locale: "en" } }),
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: "Articles — Sales & networking playbooks · Banana Cards" },
      { name: "description", content: "In-depth articles on lead generation, CRM strategy, cold outreach, and networking — written by the team behind Banana Cards." },
      { name: "keywords", content: "banana cards articles, lead generation, CRM, cold outreach, sales playbooks, digital business cards" },
      { property: "og:title", content: "Banana Cards Articles — Playbooks for modern sales" },
      { property: "og:description", content: "Deep-dive guides on AI lead generation, CRM strategy, and closing more deals with Banana Cards." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/articles` },
      { property: "og:locale", content: "en" },
      { property: "og:locale:alternate", content: "vi" },
      { name: "robots", content: "index,follow" },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/articles` },
      { rel: "alternate", hreflang: "en", href: `${SITE_URL}/articles` },
      { rel: "alternate", hreflang: "vi", href: `${SITE_URL}/vi/articles` },
      { rel: "alternate", hreflang: "x-default", href: `${SITE_URL}/articles` },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Banana Cards Articles — Sales & networking playbooks",
          description: "In-depth articles on lead generation, CRM strategy, cold outreach, and networking — written by the team behind Banana Cards.",
          url: `${SITE_URL}/articles`,
          isPartOf: { "@type": "WebSite", name: "banana.cards", url: SITE_URL },
        }),
      },
    ],
  }),
});

function RouteComponent() {
  const initialData = Route.useLoaderData();
  return <ArticlesHub locale="en" dict={HUB_DICT_EN} initialData={initialData} />;
}